export namespace SymbolAssetsTranslator {
  export function fromApi(assets: string[]): string[] {
    if (!assets) {
      return [];
    }
    // exclude nulls
    return assets.filter(Boolean);
  }
}
